/**
 * @typedef {object} SourceGroup
 * @property {string} source
 * @property {Array<{ version: number, image_url: string, is_current: boolean }>} files
 * @property {{ version: number, image_url: string }} current
 */

/**
 * Choose the selected version for each source group on a detail page's image
 * selector: the source's current version, or its newest when none is current.
 * @param {SourceGroup[]} groups output of `_sourceGroups(rows)`
 * @returns {Record<string, number>} map of source -> selected version
 */
export function defaultSelectedVersions(groups) {
    /** @type {Record<string, number>} */
    const selection = {};
    for (const { source, files, current } of groups) {
        // Files are sorted newest-first.
        const version = current?.version ?? files[0]?.version;
        if (version != null) selection[source] = version;
    }
    return selection;
}
